import { render, staticRenderFns } from "./admindiscount_whole.vue?vue&type=template&id=d983266e&"
import script from "./admindiscount_whole.vue?vue&type=script&lang=js&"
export * from "./admindiscount_whole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports